module.exports = "# Esmeralda and Goober Story\n\nYouTube: Ka3bcyUj6TU\n\n## Notes\nEsmeralda and Goober storyline wrap-up (2:19).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridPrimaries/sections/11_esGooberStory/level3_egstory.md
// module id = 1571
// module chunks = 2